import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, createElementVNode as _createElementVNode, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, createBlock as _createBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-1e6e35a5"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "task-history-order__menu-item" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, "История очередности", -1))
const _hoisted_3 = { class: "task-history-order__creator-info" }
const _hoisted_4 = {
  key: 1,
  class: "task-history-order__empty-list"
}
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, "В истории пусто", -1))

import {
  PopoverPositionEnum,
  TirPmContextMenuButton,
  TirPmIconView,
  TirPmScrollbar,
  TirPmTooltipElement,
  TirPmPopover,
} from 'tir-components';
import { ChevronRightIcon, WalletIcon } from 'tir-style-system/icons/outline';
import { onMounted, ref } from 'vue';
import { GetOrderHistoryListRequestModel, GetOrderHistoryListResponseItemModel } from './models';
import { AdapterService } from './adapter';
import OrderTaskHistoryTypeEnum from './enums/OrderTaskHistoryTypeEnum';
import { PageRequestModel } from '@/models';

/**Адаптер */

export default /*#__PURE__*/_defineComponent({
  __name: 'task-history-order',
  props: {
  /**id юзера */
  userId: { type: Number },
  /**ID задачи */
  taskId: { type: Number },
},
  setup(__props) {

const props = __props;

const adapter = new AdapterService();

/**Параметры */


/**История очередности получена */
const isHistoryLoaded = ref(false);
/**История очередности */
const historyOrder = ref<GetOrderHistoryListResponseItemModel[]>([]);
/**Кол-во истории очередности */
const historyOrderCount = ref<number>();
/**Загрузка */
const isLoading = ref<boolean>();

/**После рендера компонента */
onMounted(async () => {
  await getHistoryOrder();
});

/**Получить дату */
const getDateCreated = (date: Date) => {
  return new Date(date).toLocaleDateString('ru-RU', {
    day: 'numeric',
    month: 'short',
  });
};
/**Получить время */
const getTimeCreated = (_date: Date) => {
  const date = new Date(String(_date).replace(/z/gi, ''));
  const timeZone = date.getTimezoneOffset() / 60;
  date.setHours(date.getHours() - timeZone);

  return date.toLocaleTimeString('ru-RU', {
    hour: '2-digit',
    minute: '2-digit',
  });
};
/**Возвращает текстовое описание действия на основании его типа */
const getActionDescription = (actionType: OrderTaskHistoryTypeEnum) => {
  switch (actionType) {
    case OrderTaskHistoryTypeEnum.Attach:
      return 'Помещен';
    case OrderTaskHistoryTypeEnum.Remove:
      return 'Исключен';
    case OrderTaskHistoryTypeEnum.MoveLower:
      return 'Перемещен выше';
    case OrderTaskHistoryTypeEnum.MoveUpper:
      return 'Перемещен ниже';
  }
};
/**Получить историю изменений */
const getHistoryOrder = async () => {
  if (isHistoryLoaded.value) return;
  isLoading.value = true;

  const response = await adapter.getOrderHistoryList(
    new GetOrderHistoryListRequestModel({
      PerformerId: props.userId,
      TaskId: props.taskId,
      Page: new PageRequestModel({
        Skip: 0,
        Take: 10,
      }),
    }),
  );
  if (response.IsSuccess) {
    historyOrder.value = response.Value.Items;
    isHistoryLoaded.value = true;
  }
  isLoading.value = false;
};
/**Получить следующую историю изменений */
const getNextHistoryOrder = async () => {
  if (historyOrderCount.value == historyOrder.value.length) return;

  const response = await adapter.getOrderHistoryList(
    new GetOrderHistoryListRequestModel({
      PerformerId: props.userId,
      TaskId: props.taskId,
      Page: new PageRequestModel({
        Skip: historyOrder.value.length,
        Take: 10,
      }),
    }),
  );
  if (response.IsSuccess) {
    historyOrder.value.push(...response.Value.Items);
    historyOrderCount.value = response.Value.Page.Count;
  }
};
/**Скролинг плашки с историей изменений */
const onScroll = async (event: Event) => {
  const scrollElement = event.target as HTMLElement;
  const isScrollBottom =
    scrollElement.scrollTop + scrollElement.clientHeight >= scrollElement.scrollHeight;

  if (isScrollBottom) await getNextHistoryOrder();
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_unref(TirPmPopover), {
    isNoTeleport: "",
    disableContentBlur: "",
    width: "32.5rem",
    class: "task-history-order__menu-item--popover",
    position: _unref(PopoverPositionEnum).Right
  }, {
    default: _withCtx(() => [
      _createVNode(_unref(TirPmContextMenuButton), null, {
        right: _withCtx(() => [
          _createVNode(_unref(ChevronRightIcon), { class: "task-history-order__icon" })
        ]),
        default: _withCtx(() => [
          _createElementVNode("div", _hoisted_1, [
            _createVNode(_unref(WalletIcon), { class: "task-history-order__icon" }),
            _hoisted_2
          ])
        ]),
        _: 1
      })
    ]),
    content: _withCtx(() => [
      (historyOrder.value.length)
        ? (_openBlock(), _createBlock(_unref(TirPmScrollbar), {
            key: 0,
            showOnHover: "",
            class: "task-history-order__scrollbar",
            onOnScroll: onScroll
          }, {
            default: _withCtx(() => [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(historyOrder.value, (historyElement) => {
                return (_openBlock(), _createElementBlock("div", {
                  key: historyElement.TaskId,
                  class: "task-history-order__history-item"
                }, [
                  _createVNode(_unref(TirPmTooltipElement), { isNoTeleport: "" }, {
                    default: _withCtx(() => [
                      _createVNode(_unref(TirPmIconView), {
                        isRounded: "",
                        isBordered: false,
                        size: 24,
                        imageLoadUrl: historyElement.Creator.ImageUrl,
                        colorCode: historyElement.Creator.AvatarColor
                      }, {
                        mainSlot: _withCtx(() => [
                          _createTextVNode(_toDisplayString(historyElement.Creator.FirstName[0]) + _toDisplayString(historyElement.Creator.LastName[0]), 1)
                        ]),
                        _: 2
                      }, 1032, ["imageLoadUrl", "colorCode"])
                    ]),
                    content: _withCtx(() => [
                      _createElementVNode("div", _hoisted_3, _toDisplayString(historyElement.Creator.FirstName) + " " + _toDisplayString(historyElement.Creator.LastName), 1)
                    ]),
                    _: 2
                  }, 1024),
                  _createElementVNode("div", null, _toDisplayString(getDateCreated(historyElement.DateCreate)) + " [" + _toDisplayString(getTimeCreated(historyElement.DateCreate)) + "] " + _toDisplayString(getActionDescription(historyElement.Type)), 1)
                ]))
              }), 128))
            ]),
            _: 1
          }))
        : (_openBlock(), _createElementBlock("div", _hoisted_4, [
            _createVNode(_unref(TirPmIconView), {
              isBordered: false,
              size: 56
            }, {
              mainSlot: _withCtx(() => [
                _createVNode(_unref(WalletIcon), { class: "task-history-order__big-iron" })
              ]),
              _: 1
            }),
            _hoisted_5
          ]))
    ]),
    _: 1
  }, 8, ["position"]))
}
}

})